import * as React from 'react';
import { TextEdit } from '../../../text-edit';
import { TextBlockProps } from './text-block.types';
import { useTextBlockController } from './text-block.controller';
import { I18n } from 'react-redux-i18n';
import { Title } from '../../../title';
import { BackBtn } from '../../../back-btn';
import { Subtitle } from '../../../subtitle';
import { RadioGroup, RadioGroupValue } from '../../../radio-group';
import { SkipLogic } from '@common/components/skip-logic';
import { MODULE_NAME } from '@modules/fhq-design-tool/constants/shared';
import { SkipLogicPredefinedControlType, SkipLogicProps } from '@common/components/skip-logic/skip-logic.types';
import { TextEditor } from '../../../text-editor';
import { ErrorText } from '@common/components/error-text';

import './text-block.styles.scss';

export const TextBlock: React.FC<TextBlockProps> = (props) => {
  const { data, onGoBack, getFieldsForSkipLogic, getFoldersForSkipLogic, errors } = props;

  const {
    fieldSkipLogicConditions,
    handleSkipLogicChange,
    handleSkipLogicConditionAdd,
    handleUseSkipLogicChange,
    handleTextBlockNameChange,
    handleTextBlockDescriptionChange,
  } = useTextBlockController(props);

  return (
    <div className="FhqDesignToolQuestionnaireDesignerTextBlock" >
      <BackBtn className="FhqDesignToolQuestionnaireDesignerTextBlock__back-btn" onClick={onGoBack} />
      
      <TextEdit
        metadata={{
          description: 'text-block-name',
        }}
        value={data.title}
        onChange={handleTextBlockNameChange}
      />

      <Subtitle type="chip" text={I18n.t('Text Block')} />
      <TextEditor
        required
        metadata={{
          description: 'text-block-description',
        }}
        label={I18n.t('Text Display')}
        value={data.text ?? ''}
        onChange={handleTextBlockDescriptionChange}
      />
      {errors?.content?.map((error, i) => (
        <ErrorText
          withTopGap
          text={error.text} 
          key={typeof error.text === 'string' ? error.text : i} 
        />
      ))}

      <Title text={I18n.t('Skip Logic')} />
      <Subtitle 
        text={I18n.t('skipLogicDescriptionTextBlock')}
      />
      <RadioGroup
        margin="12px 0 12px 0"
        value={`${data.skipLogicEnabled ?? false}`}
        options={[
          { id: "false", name: I18n.t("Show Always") },
          { id: "true", name: I18n.t("Show only if condition below is true"), },
        ]}
        onChange={handleUseSkipLogicChange as (v: RadioGroupValue) => void}
        metadata={{
          description: "field-use-skip-logic",
        }}
      />
      {data.skipLogicEnabled && (
        <SkipLogic
          moduleName={MODULE_NAME}
          className="FhqDesignToolQuestionnaireDesignerTextBlock__skip-logic"
          conditions={fieldSkipLogicConditions}
          onRemove={handleSkipLogicChange}
          onChange={handleSkipLogicChange}
          onAdd={handleSkipLogicConditionAdd as SkipLogicProps['onAdd']}
          getFolders={getFoldersForSkipLogic}
          getFields={getFieldsForSkipLogic}
          controls={[
            { type: SkipLogicPredefinedControlType.moveUp, handler: handleSkipLogicChange },
            { type: SkipLogicPredefinedControlType.moveDown, handler: handleSkipLogicChange },
            { type: SkipLogicPredefinedControlType.add },
          ]}
        />
      )}
    </div>
  );
};